import React from 'react';

//
import MainTitle from '../../components/page/main-title/MainTitle';
import WS from '../../config/Ws';
import Requisitions from '../../utils/requisitions/Requisitions';
import './page.css';
import Dialog from '../../components/alert/Dialog';
import STRINGS from './../../data/language/language';
import Modal from '../../components/modal.v2/Modal';
import Detail from './Detail';

const URL = WS.exercicios;

class Page extends React.Component{
  constructor (props){
    super(props);

    this.state = {
      strings:STRINGS[window.LANGUAGE],
      loaded: false
    };

    this.openDetail = this.openDetail.bind(this);
  }

  componentDidMount() {
    //dá um scroll no window pois quando carregamos uma nova tela
    //se a anterior tivesse sido rolada para baixo a página ficava na posição errada no topo
    window.scrollTo(0, 0);

    const {atencao} = this.state.strings;
    let _self = this;

    Requisitions({
      url: URL.lista,
      data: window.dadosUser,
      sucess:function(data){
        var msg;

        if(data.status){
          _self.setState({
            lista: data.data,
            loaded: true
          });
        }else{
          msg = {
            title: atencao,
            text: data.msg
          };
          Dialog.create(msg);
        }
        _self.setState({
          isLoading: false
        });
      },
      error:function(data){
        console.log(data);
      }
    });
  }

  openDetail(e, id) {
    const {atencao} = this.state.strings;
    let _self = this;
    const d = {...window.dadosUser};
    d.id = id;
    Requisitions({
      url: URL.detalhe,
      data: d,
      sucess:function(data){
        var msg;

        if(data.status){
          Modal.create({
            content: <Detail data={data.data} />
          });
        }else{
          msg = {
            title: atencao,
            text: data.msg
          };
          Dialog.create(msg);
        }
        _self.setState({
          isLoading: false
        });
      },
      error:function(data){
        console.log(data);
      }
    });

    e.preventDefault();
  }

  getView() {
    let lista = this.state.lista.map((value, i) =>
        <a href="#" key={i} className='link-detail' onClick={(e) => this.openDetail(e,value.id)}>
          {value.nome}
          <i className="fas fa-chevron-right"></i>
        </a>
      );

    return lista;
  }

  render() {
    const view = this.state.loaded ? this.getView() : null;
    return (
      <div className="page-dashboard page-content" >
        <div className="container">
          <div className="container-box">
            <div className="container-box--inner">
              <MainTitle title="Exercícios"></MainTitle>
              <div>
                {view}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Page;



// WEBPACK FOOTER //
// ./src/classes/exercicios/Page.js